/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['../constants'], function(constants) {
	'use strict';
	class Rave2bundlebullet {
		get config(){
			return {
				'type':'Bullet',
				'thumbnail': {
					'properties': {
						'valueAxis.ticks.labels.visible': false
					}
				},
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'doesNotSupportAnnotations': true,
				'doesNotSupportCustomGroupAction': true,
				'doesNotSupportTooltipSlot': true,
				'slots':{
					'actual':{
						'optional':false,
						'icon':'y-axis_columns',
						'actions': [
							'formatAction',
							'text'
						],
						'tags': ['canUseToColor']
					},
					'goal':{
						'optional':true,
						'icon':'target',
						'actions': [
							'formatAction'
						],
						'tags': ['canUseToColor']
					},
					'min':{
						'optional':true,
						'icon':'values',
						'actions': [
							'formatAction'
						]
					},
					'mid':{
						'optional':true,
						'icon':'values',
						'actions': [
							'formatAction'
						]
					},
					'max':{
						'optional':true,
						'icon':'values',
						'actions': [
							'formatAction'
						]
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc',
						'actions': [
							'sortAction',
							'formatAction',
							'topBottomAction',
							'filter'
						]
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'actions': [
							'sortAction',
							'formatAction',
							'topBottomAction',
							'filter'
						]
					}
				},
				'propertyPrefixes': {
					'legend': 'widget.legend'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'properties':{
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'chart.title.color': {
						active: false
					},
					'chart.title.auto.areawidth': {
						active: false
					},
					'chart.title.areawidth': {
						active: false
					},
					'chart.title.visible': {
						active: false,
						'defaultValue': false,
						'isReadOnly': true
					},
					'itemAxisSubtitle':{
						'active':false
					},
					'widget.legend.size': {
						'active': false
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'valueAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'color.min': {
						colorClass: true,
						'addButton': true
					},
					'color.mid': {
						colorClass: true,
						'addButton': true
					},
					'color.max': {
						colorClass: true,
						'addButton': true
					},
					'color.title': {
						'multilingual': true
					},
					'valueAxis.minValue': constants.minMaxValidationOptions,
					'valueAxis.maxValue': constants.minMaxValidationOptions,
					'valueAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.ticks.labels.rotateAngle': {
						'percentage': false
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				config:{
					'include':[
						'valueAxis.minValue',
						'valueAxis.maxValue',
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'chart.title.color',
						'chart.title.visible',
						'chart.title.areawidth',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'actions',
						'color.min',
						'color.mid',
						'color.max',
						'color.actual',
						'color.goal',
						'color.title',
						'itemAxis.title',
						'valueAxisTitleColor',
						'itemAxis.title',
						'itemAxisSubtitle',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.swatch.symbol.default',
						'valueAxis.ticks.labels.visible',
						'valueAxis.ticks.visible',
						'valueAxis.ticks.labels.font',
						'valueAxis.ticks.labels.color',
						'valueAxis.logarithmic',
						'color.actual',
						'color.goal',
						'widget.legend.size',
						'valueAxis.tickInterval',
						'optimizeSize',
						'valueAxis.line.color',
						'valueAxis.line.visible',
						'transpose',
						'itemAxis.ticks.labels.rotateAngle',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color'

					],
					'exclude':[
						'subtitle.visible'
					]
				},
				usages:[
					'Comparison'
				],
				'supportsMaintainAxisScale': false,
				'colorPalettes': {
					'single': {
						'color.actual': {
							id: 'defaultPaletteIndex',
							labelId: 'propBarColor',
							defaultColorIndex: 0
						},
						'color.goal': {
							id: 'goal_color',
							labelId: 'propGoalColor',
							defaultColorIndex: 1
						}
					}
				}
			};
		}
	}
	return Rave2bundlebullet;
});
